import { getStore } from '@/utils/dva'

/**
 * 判断是否大店
 * @param coId
 * @returns
 */
const getCoIdIsBigShopByCoId = (coId: string | number) => {
    if (coId) {
        const currentBigShopCoIdList = getStore().getState().menu?.bigShopCoIdList || []
        return currentBigShopCoIdList.includes(String(coId))
    }
    return false
}
export default getCoIdIsBigShopByCoId
